/**
 * ISO 날짜 문자열을 "yyyy. MM. dd" 형태로 표시한다. 예) "2026-08-12" → `"2026. 08. 12"`
 *
 * `toLocaleDateString("ko-KR", ...)`이 만드는 값은 끝에 마침표가 하나 더 붙는데("2026. 08. 12."),
 * 그 마지막 마침표만 잘라낸다.
 *
 * @param isoString ISO 형식 날짜 문자열
 * @returns "yyyy. MM. dd" 형태 문자열
 */
export default function formatDate(isoString: string): string {
  const date = new Date(isoString);
  const formattedDate = date.toLocaleDateString("ko-KR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  // 마지막에 붙는 마침표 제거
  return formattedDate.endsWith(".")
    ? formattedDate.slice(0, -1)
    : formattedDate;
}
